import styled from 'styled-components';

import { media } from 'helpers/breakpoints';
import { MediaHighlight } from 'components/Toolkit/Tags/MediaHighlight';

import {
  Next,
  Previous,
} from 'components/Toolkit/Gallery/components/GalleryUiElements';

const Wrapper = styled.div<{ isDealer: boolean; isPreview?: boolean }>`
  background-color: ${({ theme }) => theme.colors.WHITE};
  border-bottom-left-radius: ${({ theme }) => theme.borderRadius.default};
  border-bottom-right-radius: ${({ theme }) => theme.borderRadius.default};
  overflow: hidden;
  position: relative;
  width: 100%;
  cursor: ${({ isPreview }) => (isPreview ? 'not-allowed' : 'pointer')};

  ${media.large} {
    border-radius: ${({ theme, isDealer }) =>
      isDealer
        ? `0 0 ${theme.borderRadius.default} ${theme.borderRadius.default}`
        : theme.borderRadius.default};
  }
`;

const Overview = styled.div`
  bottom: ${({ theme }) => theme.spacing.M16};
  left: ${({ theme }) => theme.spacing.M16};
  position: absolute;
  display: flex;

  ${media.large} {
    left: ${({ theme }) => theme.spacing.M24};
  }
`;

const SMediaHighlight = styled(MediaHighlight)`
  margin-left: ${({ theme }) => theme.spacing.S8};
`;

const WatchReview = styled(SMediaHighlight)`
  span {
    display: inline-block;
    margin-left: 0.25em;
    ${({ theme }) => theme.fontSize.B12};
  }
`;

const Img = styled.img`
  object-fit: cover;
  width: 100%;
  height: 226px;

  @media screen and (min-width: 374px) {
    height: 246px;
  }

  @media screen and (min-width: 413px) {
    height: 300px;
  }

  @media screen and (min-width: 450px) {
    height: 300px;
    object-fit: contain;
  }

  ${media.large} {
    height: 432px;
  }
`;

const SNext = styled(Next)`
  right: ${({ theme }) => theme.spacing.S8};
  display: none;

  ${media.large} {
    display: block;
  }
`;

const SPrevious = styled(Previous)`
  left: ${({ theme }) => theme.spacing.S8};
  display: none;

  ${media.large} {
    display: block;
  }
`;

const Ssvg = styled.svg`
  position: absolute;
  margin: auto auto;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 62px;
  width: 88px;

  & path:first-child:hover {
    fill: ${({ theme }) => theme.colors.RED_DARK};
  }
`;

export {
  Wrapper,
  SPrevious,
  SNext,
  Img,
  WatchReview,
  Overview,
  SMediaHighlight,
  Ssvg,
};
